import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Grid, TextField, makeStyles } from "@material-ui/core";
import axios from "axios";
import moment from "moment";
import { LoadingButton } from "@material-ui/lab";
import { CSVLink } from "react-csv";
import SubCard from "../../../ui-component/cards/SubCard";
import { Checkbox, Typography } from "@mui/material";
import { getDecryptDataFromLocal } from "../../../utils/encrypt";

const orderTypes = {
  1:'BULK',
  2:'GT',
  3:"E-COMMERCE"
}
const bulkChildOrderHeader = [
  { label: "Name", key: "name" },
  { label: "ProductId", key: "productId" },
  { label: "productName", key: "productName" },
  // { label: "PhoneNumber", key: "phoneNumber" },
  { label: "EANCode", key: "EANCode" },
  // { label: "HSNCode", key: "HSNCode" },
  // { label: "baseDiscountAmount", key: "baseDiscountAmount" },
  // { label: "brandId", key: "brandId" },
  { label: "Brand Name", key: "brandName" },
  // { label: "cashBackDiscount", key: "cashBackDiscount" },
  // { label: "comboDiscounts", key: "comboDiscounts" },
  // { label: "couponDiscountAmount", key: "couponDiscountAmount" },
  // { label: "couponDiscountPercentInDecimal", key: "couponDiscountPercentInDecimal" },
  { label: "createdAt", key: "createdAt" },
  // { label: "discountOnOrder", key: "discountOnOrder" },
  // { label: "discountRatio", key: "discountRatio" },
  // { label: "festivalDiscountPercentInDecimal", key: "festivalDiscountPercentInDecimal" },
  // { label: "flashSaleDiscountAmount", key: "flashSaleDiscountAmount" },
  // { label: "gstRate", key: "gstRate" },
  // { label: "isAutoApproved", key: "isAutoApproved" },
  // { label: "isFreeProduct", key: "isFreeProduct" },
  // Uncommented 2026-09-16 — needed to tell FBL Prime rows (synthesized
  // server-side, see synthesizeFblPrimeProductRows in controllers/sales.js)
  // apart from real SKUs: 'Prime Membership' / 'Prime Free Gift' vs the
  // normal 'Normal'/'Coin'/'Free'.
  { label: "productType", key: "productType" },
  { label: "isRetail", key: "isRetail" },
  { label: "isSplitedOrder", key: "isSplitedOrder" },
  // { label: "lightningDiscountAmount", key: "lightningDiscountAmount" },
  // { label: "memberShipDiscountPercentInDecimal", key: "memberShipDiscountPercentInDecimal" },
  // { label: "membershipDiscountAmount", key: "membershipDiscountAmount" },
  { label: "mrp", key: "mrp" },
  { label: "mrpPerSku", key: "mrpPerSku" },
  { label: "numericOrderId", key: "numericOrderId" },
  { label: "mainBulkNumericOrderId", key: "mainBulkNumericOrderId" },
  { label: "Parent Bulk NumericOrderId", key: "parentBulkNumericOrderId" },
  { label: "orderStage", key: "orderStageV2" },
  { label: "orderType", key: "orderType" },
  { label: "Shipping Type", key: "shippingType" },
  { label: "Weight", key: "weight" },
  { label: "Box Count", key: "boxCount" },
  { label: "price", key: "price" },
  // { label: "productType", key: "productType" },
  { label: "quantity", key: "quantity" },
  { label: "status", key: "status" },
  { label: "totalPayableAmount", key: "totalPayableAmount" },
  // { label: "cnDiscount", key: "cnDiscount" },
  // { label: "bulkMargin", key: "bulkMargin" },
  { label: "zohoInvoice", key: "zohoInvoice" },
  { label: "zohoInvoiceDate", key: "zohoInvoiceDate" },
  { label: "zohoInvoiceUrl", key: "zohoInvoiceUrl" },
  { label: "zohoInvoiceCreditNoteNumber", key: "zohoInvoiceCreditNoteNumber" },
  { label: "ucInvoiceIdsForBulkOrder", key: "ucInvoiceIdsForBulkOrder" },
  { label: "agentName", key: "agentName" },
  { label: "awbNumber", key: "awbNumber" },
  {label: "immediateSenior", key: "immediateSenior"},
  {label: "Manager", key: "managerName"},
  {label: "city", key: "city"},
  {label: "state", key: "state"},
  {label: "pincode", key: "pincode"},
  {label: "agentId", key: "agentId"},
  {label: "sellerId", key: "sellerId"},
  {label: "shippingCost", key: "shippingCost"},
  {label: "rtoDeliveryDate", key: "rtoDeliveryDate"},
  {label: "RTO Delivered Date", key: "rtoDeliveredDate"},
  {label: "Actual Discount", key: "actualDiscount"},
  {label: "Marked As Pending", key: "markedAsPending"},
  {label: "Old Order Date", key: "oldOrderDate"},
  { key: "stage1", label: "Stage 1 Date" },
  { key: "stage2", label: "Stage 2 Date" },
  { key: "stage3", label: "Stage 3 Date" },
  { key: "stage4", label: "Stage 4 Date" },
  { key: "stage5", label: "Stage 5 Date" },
  { key: "stage6", label: "Stage 6 Date" },
  {label: "Cancelled At", key: "cancelledAt"},
  {label: "Cancel Reason", key: "cancelReason"},
  {label: "invoiceValue", key: "invoiceValue"},
  {label: "taxable", key: "taxable"},
  {label: "InvoiceRate", key: "InvoiceRate"},
  {label: "sgst", key: "sgst"},
  {label: "cgst", key: "cgst"},
  {label: "igst", key: "igst"},
  { label: "First Out For Delivery Date", key: "firstOutForDeliveryDate" },
  { label: "Out For Delivery Count", key: "outForDeliveryCount" },
  { label: "At Delivery Center Date", key: "atDeliveryCenterDate" },
  { label: "Reached At Destination Date", key: "reachedAtDestinationAt" },
  { label: "Verified By", key: "verifiedByName" },
];

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));
function BulkDownloadProductData() {
  const classes = useStyles();
  const currentRole = getDecryptDataFromLocal('setRole');
  const currentPhone = getDecryptDataFromLocal('phoneNumber');

  // Access guard: userType 1, 2, 3, 4, 17, 5 (agent), 13/14 (TL/FM), Manjay (bulkWaManager), or phone 9873804039.
  // Backend scopes the data per user (agent -> self, TL/FM -> own team, Ameen -> all retail, Manjay -> bulk team only).
  const allowedRoles = [1, 2, 3, 4, 17, 5, 13, 14];
  const allowedPhone = '9873804039';
  let isBulkWaManager = false;
  try { isBulkWaManager = localStorage.getItem('bulkWaManager') === 'true'; } catch (e) { /* ignore */ }
  if (!allowedRoles.includes(Number(currentRole)) && currentPhone != allowedPhone && !isBulkWaManager) {
    return <Redirect to="/dashboard/default" />;
  }
  const [date, setDate] = useState({
    startDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
    endDate: new Date().toISOString().slice(0, 10),
  });
  const [pageLoad, togglePageLoad] = useState(true);
  const [checkCancelOrder,setCheckCancelOrder] = useState(false)
  console.log('checkCancelOrdercheckCancelOrder',checkCancelOrder)

  const [downloadBulkData, setDownBulkData] = useState([]);
  const [loading, setLoading] = useState(false);

  const dataLoad = async () => {
    setLoading(true);
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/sales/downloadBulkOrderData", {
        startDate: date.startDate,
        endDate: date.endDate,
        productWise:true,
        cancelledOrder:checkCancelOrder
      })
      .then((res) => {
        if (res.data.success) {
           res.data.data.forEach((item)=>{
            item.orderType = orderTypes[item.orderType]
            item?.orderStageV2Log && item?.orderStageV2Log.length>0 && item?.orderStageV2Log.forEach((logs)=>{
              if(logs.stageChangedTo==1){
                item.stage1 = moment(logs.stageChangedAt).format('hh:mm A DD-MM-YYYY')
              }
              if(logs.stageChangedTo==2){
                item.stage2 = moment(logs.stageChangedAt).format('hh:mm A DD-MM-YYYY')
              }
              if(logs.stageChangedTo==3){
                item.stage3 = moment(logs.stageChangedAt).format('hh:mm A DD-MM-YYYY')
              }
              if(logs.stageChangedTo==4){
                item.stage4 = moment(logs.stageChangedAt).format('hh:mm A DD-MM-YYYY')
              }
              if(logs.stageChangedTo==5){
                item.stage5 = moment(logs.stageChangedAt).format('hh:mm A DD-MM-YYYY')
              }
              if(logs.stageChangedTo==6){
                item.stage6 = moment(logs.stageChangedAt).format('hh:mm A DD-MM-YYYY')
              }
             }) 
          })
          setDownBulkData(res.data.data || []);
          togglePageLoad(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error of get data", error);
      });
  };


  if (!pageLoad) {
    return (
      <div>
        <h1>Loading</h1>
      </div>
    );
  }

  return (
    <SubCard title={"Download Bulk Product Data"}>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid xs={12} sm={12} md={6} lg={3} item>
          <TextField
            id="datetime-local"
            label="Start Date"
            type="date"
            defaultValue={date.startDate}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            style={{
              width: "100%",
            }}
            onChange={(e) =>
              setDate({
                ...date,
                startDate: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextField
            id="datetime-local"
            label="End Date"
            type="date"
            defaultValue={date.endDate}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            style={{
              width: "100%",
            }}
            onChange={(e) =>
              setDate({
                ...date,
                endDate: e.target.value,
              })
            }
          />
        </Grid>
        <Grid container item xs={12} sm={6} md={2} lg={2} alignItems={'center'}>
          <Checkbox 
            value={checkCancelOrder}
            onChange={(e)=>setCheckCancelOrder(e.target.checked)}
            checked={checkCancelOrder}
            size='medium'
          />
          <Typography fontSize={18}>Cancel Order</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <LoadingButton
            variant="contained"
            style={{
              width: "100%",
            }}
            loadingIndicator="loading..."
            onClick={() => dataLoad()}
            loading={loading}
          >
            Submit
          </LoadingButton>
        </Grid>
        <Grid item lg={3} md={3} sm={12}>
          {!loading && downloadBulkData.length > 0 && (
            <CSVLink
              filename="BulkProductData.csv"
              headers={bulkChildOrderHeader}
              data={downloadBulkData}
              title="Download data"
              style={{
                textDecoration: "none",
                border: "1px solid #999",
                padding: "10px 20px",
                backgroundColor: "#95c7f1",
              }}
            >
              Download data
            </CSVLink>
          )}
        </Grid>
      </Grid>
    </SubCard>
  );
}

export default BulkDownloadProductData;
